import dates from './dates'

const querystring = {
  dateRange(startDate, endDate) {
    const startDateValue = startDate.format('YYYY-MM-DD')
    const endDateValue = endDate.format('YYYY-MM-DD')

    return `and=(date.gte.${startDateValue},date.lte.${endDateValue})`
  },
  mtd() {
    const [startDate, endDate] = dates.mtd()

    return this.dateRange(startDate, endDate)
  },
  date(date = {}) {
    const { operator = 'gte', value = [] } = date

    if (value.length > 1) {
      const [startDate, endDate] = value
      return this.dateRange(startDate, endDate)
    }

    const dateValue = value[0].format('YYYY-MM-DD')

    return `and=(date.${operator}.${dateValue})`
  },
  dates(dateRangeArray) {
    if (!dateRangeArray || !dateRangeArray.length) return this.mtd()

    const [startDateValue, endDateValue] = dateRangeArray

    if (typeof startDateValue === 'object') {
      return this.date(startDateValue)
    }

    const startDate = dates.get(startDateValue)
    const endDate = dates.get(endDateValue)

    return this.dateRange(startDate, endDate)
  },
}

export default querystring
